import { AxiosResponse } from 'axios'
import { INewUser } from '../../components/forms/AddUserForm/types'
import axiosInstance from '../../config/axios'
import { ISubjectDTO, IVictimDTO, IVictimDTO2 } from '../../store/users/types'

import usersUrls from '../../utils/urls/usersUrls'

const getAllByName = (): Promise<AxiosResponse> => axiosInstance.get(usersUrls.users())

const resetUsersPassword = (userId: number): Promise<AxiosResponse> =>
  axiosInstance.post('', { userId })

const deactivateUser = (userId: number): Promise<AxiosResponse> =>
  axiosInstance.post('', { userId })

const postNewUser = (userData: INewUser): Promise<AxiosResponse> => {
  const formData = new FormData()
  const user = userData.user

  for (const key in user) {
    formData.append(`user.${key}`, user[key] as string)
  }

  const userProfile = userData.userprofile
  formData.append('userprofile.organization', userProfile.organization as string)
  formData.append('userprofile.profile_pic', userProfile.profile_pic as unknown as File)

  const roles = userProfile.roles as number[]
  for (let i = 0; i < roles.length; i++) {
    formData.append('userprofile.roles', roles[i] as unknown as string)
  }
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
  return axiosInstance.post(usersUrls.getUsersUrl(), formData, config)
}

const patchUser = (userData: any, userId: number): Promise<AxiosResponse> => {
  return axiosInstance.patch(`${usersUrls.getUsersUrl()}${userId}/`, userData)
}

const patchUserProfile = (userData: any, userId: number): Promise<AxiosResponse> => {
  const formData = new FormData()
  const { roles, ...user } = userData

  // console.log('patchUserProfile roles', roles)

  for (const key in user) {
    formData.append(key, userData[key])
  }

  // formData.append('roles', roles)

  for (let i = 0; i < roles.length; i++) {
    formData.append('roles', roles[i] as unknown as string)
  }

  // console.log('formData', formData)
  return axiosInstance.patch(`${usersUrls.getUsersProfileUrl()}${userId}/`, formData)
}

const postNewVictim = (data: IVictimDTO) => {
  const formData = new FormData()
  const victim = data?.victim
  const customFields = data?.custom_fields

  formData.append('victim.person_type', victim.person_type)
  formData.append('victim.description', victim.description)
  formData.append('victim.report', victim.report as unknown as string)
  formData.append('victim.full_name', victim.full_name)
  // formData.append('victim.image', victim.image)
  if (typeof victim.image === 'object' && victim.image instanceof File) {
    formData.append('victim.image', victim.image);
  } else {
    // Send empty if no file
    formData.append('victim.image', '');
  }
  if (customFields && customFields.length) {
    customFields.forEach((customField, index) => {
      for (const key in customField) {
        if (Object.prototype.hasOwnProperty.call(customField, key)) {
          formData.append(`custom_fields[${index}]${key}`, customField[key])
        }
      }
    })
  }

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
  return axiosInstance.post(usersUrls.getVictimsUrl(), formData, config)
}

// TODO: update function above and remove this one
const postNewVictimNewCase = (data: IVictimDTO2) => {
  const formData = new FormData()
  const victim = data?.victim
  const customFields = data?.custom_fields

  formData.append('victim.business_unit', victim.business_unit)
  formData.append('victim.city', victim.city)
  formData.append('victim.email', victim.email)
  formData.append('victim.location', victim.location)
  if (victim.original_hire_date && victim.original_hire_date !== '')
    formData.append('victim.original_hire_date', victim.original_hire_date)
  formData.append('victim.phone', victim.phone)
  formData.append('victim.state', victim.state)
  if (victim.termination_date && victim.termination_date !== '')
    formData.append('victim.termination_date', victim.termination_date)
  formData.append('victim.title', victim.title)
  formData.append('victim.work_country', victim.work_country)
  formData.append('victim.work_site', victim.work_site)
  formData.append('victim.person_type', victim.person_type)
  formData.append('victim.full_name', victim.full_name)
  formData.append('victim.description', victim.description)
  formData.append('victim.report', victim.report as unknown as string)
  formData.append('victim.image', victim.image)
  if (customFields && customFields.length) {
    customFields.forEach((customField, index) => {
      for (const key in customField) {
        if (Object.prototype.hasOwnProperty.call(customField, key)) {
          formData.append(`custom_fields[${index}]${key}`, customField[key])
        }
      }
    })
  }

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
  return axiosInstance.post(usersUrls.getVictimsUrl(), formData, config)
}

const patchVictim = (data: IVictimDTO) => {
  const formData = new FormData()
  const victim = data?.victim
  const customFields = data?.custom_fields

  formData.append('person_type', victim.person_type)
  formData.append('description', victim.description)
  formData.append('report', victim.report as unknown as string)
  formData.append('full_name', victim.full_name)
  if (victim?.image && typeof victim.image !== 'string') {
    formData.append('image', victim.image)
  }
  if (customFields && customFields.length) {
    customFields.forEach((customField, index) => {
      for (const key in customField) {
        if (Object.prototype.hasOwnProperty.call(customField, key)) {
          formData.append(`custom_fields[${index}]${key}`, customField[key])
        }
      }
    })
  }

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
  return axiosInstance.patch(usersUrls.getVictimsUrl(`${data?.id}/`), formData, config)
}
const deleteVictim = (victimId: string): Promise<AxiosResponse> =>
  axiosInstance.delete(usersUrls.getVictimsUrl(victimId as string))

const postNewSubject = (data: ISubjectDTO) => {
  const formData = new FormData()
  const subject = data?.subject
  const customFields = data?.custom_fields

  formData.append('subject.person_type', subject.person_type)
  formData.append('subject.description', subject.description)
  formData.append('subject.report', subject.report as unknown as string)
  formData.append('subject.full_name', subject.full_name)
  // formData.append('subject.image', subject.image)
  // ✅ Safe check for File type
  if (typeof subject.image === 'object' && subject.image instanceof File) {
    formData.append('subject.image', subject.image);
  } else {
    // Send empty if no file
    formData.append('subject.image', '');
  }
  if (customFields && customFields.length) {
    customFields.forEach((customField, index) => {
      for (const key in customField) {
        if (Object.prototype.hasOwnProperty.call(customField, key)) {
          formData.append(`custom_fields[${index}]${key}`, customField[key])
        }
      }
    })
  }

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
  return axiosInstance.post(usersUrls.getSubjectsUrl(), formData, config)
}

const patchSubject = (data: ISubjectDTO) => {
  const formData = new FormData()
  const subject = data?.subject
  const customFields = data?.custom_fields

  formData.append('person_type', subject.person_type)
  formData.append('description', subject.description)
  formData.append('report', subject.report as unknown as string)
  formData.append('full_name', subject.full_name)
  // if (subject?.image && typeof subject.image !== 'string') {
  //   formData.append('image', subject.image)
  // }
  if (subject?.image) {
    formData.append('image', subject.image instanceof File ? subject.image : '');
  }
  if (customFields && customFields.length) {
    customFields.forEach((customField, index) => {
      for (const key in customField) {
        if (Object.prototype.hasOwnProperty.call(customField, key)) {
          formData.append(`custom_fields[${index}]${key}`, customField[key])
        }
      }
    })
  }

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
  return axiosInstance.patch(usersUrls.getSubjectsUrl(`${data?.id}/`), formData, config)
}

const deleteSubject = (subjectId: string): Promise<AxiosResponse> =>
  axiosInstance.delete(usersUrls.getSubjectsUrl(subjectId as string))

const postNewReportingParty = (data: any) => {
  const formData = new FormData()
  const reporting_party = data?.reporting_party
  const customFields = data?.custom_fields

  formData.append('reporting_party.person_type', reporting_party.person_type)
  formData.append('reporting_party.description', reporting_party.description)
  formData.append('reporting_party.report', reporting_party.report as unknown as string)
  formData.append('reporting_party.full_name', reporting_party.full_name)
  // formData.append('reporting_party.image', reporting_party.image)
  if (typeof reporting_party.image === 'object' && reporting_party.image instanceof File) {
    formData.append('reporting_party.image', reporting_party.image);
  } else {
    // Send empty if no file
    formData.append('reporting_party.image', '');
  }
  if (customFields && customFields.length) {
    customFields.forEach((customField: { [x: string]: string | Blob }, index: any) => {
      for (const key in customField) {
        if (Object.prototype.hasOwnProperty.call(customField, key)) {
          formData.append(`custom_fields[${index}]${key}`, customField[key])
        }
      }
    })
  }

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
  return axiosInstance.post(usersUrls.getReportingPartyUrl(), formData, config)
}

const patchReportingParty = (data: any) => {
  const formData = new FormData()
  const reporting_party = data?.reporting_party
  const customFields = data?.custom_fields

  formData.append('person_type', reporting_party.person_type)
  formData.append('description', reporting_party.description)
  formData.append('report', reporting_party.report as unknown as string)
  formData.append('full_name', reporting_party.full_name)
  if (reporting_party?.image) formData.append('image', reporting_party.image)
  if (customFields && customFields.length) {
    customFields.forEach((customField: { [x: string]: string | Blob }, index: any) => {
      for (const key in customField) {
        if (Object.prototype.hasOwnProperty.call(customField, key)) {
          formData.append(`custom_fields[${index}]${key}`, customField[key])
        }
      }
    })
  }

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }
  return axiosInstance.patch(
    usersUrls.getReportingPartyUrl(`${data?.id}/`),
    formData,
    config,
  )
}

const deleteReporter = (reporterId: string): Promise<AxiosResponse> =>
  axiosInstance.delete(usersUrls.getReportingPartyUrl(reporterId as string))

const getAllUsersInOrganization = (excludeLoggedUser = true): Promise<AxiosResponse> =>
  axiosInstance.get(usersUrls.getAllUsersUrl(excludeLoggedUser))

const getUsersRoles = (): Promise<AxiosResponse> => axiosInstance.get(usersUrls.getUserRolesUrl())

const postUserToTeam = (data: {
  investigator: number
  report: number
  message: string
  access: string
  role: string
}): Promise<AxiosResponse> => axiosInstance.post(usersUrls.getRportAssignsUrl(), data)

const patchUserToTeam = (data: {
  investigator: number
  report: number
  message: string
  access: string
  role: string
}): Promise<AxiosResponse> =>
  axiosInstance.patch(`${usersUrls.getRportAssignsUrl()}${data.investigator}/`, {
    access: data.access,
    role: data.role,
  })

const removeTeamMember = (userId: number): Promise<AxiosResponse> =>
  axiosInstance.delete(`${usersUrls.getRportAssignsUrl()}${userId}/`)

const postUserPreset = (data: { [key: string]: string }): Promise<AxiosResponse> =>
  axiosInstance.post(usersUrls.getUserPresetsUrl(), data)

const getUserPresets = (userId: string): Promise<AxiosResponse> =>
  axiosInstance.get(usersUrls.getUserPresetsUrl(), {
    params: {
      user: userId,
    },
  })

export default {
  getAllByName,
  resetUsersPassword,
  deactivateUser,
  postNewUser,
  patchUser,
  patchUserProfile,
  getAllUsersInOrganization,
  getUsersRoles,
  postUserToTeam,
  postNewVictim,
  postNewVictimNewCase,
  patchVictim,
  postNewSubject,
  deleteSubject,
  deleteVictim,
  patchSubject,
  postNewReportingParty,
  deleteReporter,
  patchReportingParty,
  postUserPreset,
  getUserPresets,
  patchUserToTeam,
  removeTeamMember,
}
